import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import AzRichText from '~/components/_next/atoms/AzRichText.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import CardSkeleton from '~/assets/images/skeletons/card.svg?inline';
import BlockCategoryTagsGraphql from '~/components/Organisms/BlockCategoryTagsGraphql.vue';
import AppCategoriesHeader from '~/components/Layout/AppCategoriesHeader.vue';
import AzRadio from '@/components/_next/molecules/AzRadio.vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import SortSelector from '~/components/ui/SortSelector.vue';
import AzPagination from '~/components/_next/molecules/AzPagination.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import MobileFiltersButton from '~/components/ui/CustomStoreFrontUI/MobileFiltersButton.vue';
import AzRecipeCard from '~/components/_next/molecules/AzRecipeCard.vue';
import AzFilter from '@/components/_next/molecules/AzFilter.vue';
import { useAlgoliaSearch } from '~/composables/_next/useAlgoliaSearch';
import AzAccordionItem from '@/components/_next/molecules/AzAccordionItem.vue';
import { AisConfigure, AisHits, AisRefinementList, AisSortBy, AisStats, AisClearRefinements } from 'vue-instantsearch';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import { useUser } from '~/composables/_next/useUser';
import { useRecipeListingStore } from '~/composables/_next/stores/useRecipeListingStore';
import AzButtonText from '~/components/_next/atoms/AzButtonText.vue';
import { z } from 'zod';
import { instantScrollTo } from '~/helpers/ui/windowBehaviors';
import { HITS_PER_PAGE } from '~/constants/recipesConstants';
export default /*#__PURE__*/_defineComponent({
  __name: 'AlgoliaRecipes',
  setup: function setup(__props) {
    var _useRecipesWishlists = useRecipesWishlists(),
      isInRecipesWishlists = _useRecipesWishlists.isInRecipesWishlists,
      removeRecipeFromWishlist = _useRecipesWishlists.removeRecipeFromWishlist;
    var _useUiState = useUiState(),
      toggleAddRecipeToWishlistSidebar = _useUiState.toggleAddRecipeToWishlistSidebar;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      navigateToOrLogin = _useAuthenticatedActi.navigateToOrLogin;
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n,
      app = _useNuxt2App.app,
      error = _useNuxt2App.error;
    var _useAlgoliaSearch = useAlgoliaSearch(),
      filtersRecipes = _useAlgoliaSearch.filtersRecipes,
      sortsRecipes = _useAlgoliaSearch.sortsRecipes;
    var searchQuery = ref('');
    function updateRecipeWishlist(recipe) {
      if (isAuthenticated.value) {
        var wishlisted = isInRecipesWishlists(recipe.recipeId || (recipe === null || recipe === void 0 ? void 0 : recipe.id));
        if (wishlisted) {
          removeRecipeFromWishlist((recipe === null || recipe === void 0 ? void 0 : recipe.recipeId) || (recipe === null || recipe === void 0 ? void 0 : recipe.id));
        } else {
          toggleAddRecipeToWishlistSidebar({
            contentfulId: (recipe === null || recipe === void 0 ? void 0 : recipe.recipeId) || (recipe === null || recipe === void 0 ? void 0 : recipe.id),
            image: recipe.photo,
            name: recipe.title
          });
        }
      } else {
        navigateToOrLogin({
          nextRoutePath: route.path,
          previousRoutePath: route.path
        });
      }
    }
    var sidebar = ref(null);
    /**
     * Opens the filters sidebar.
     */
    function openSidebar() {
      var _sidebar$value, _sidebar$value$sideba;
      (_sidebar$value = sidebar.value) === null || _sidebar$value === void 0 ? void 0 : (_sidebar$value$sideba = _sidebar$value.sidebar) === null || _sidebar$value$sideba === void 0 ? void 0 : _sidebar$value$sideba.showModal();
    }
    var _useRecipeListingStor = useRecipeListingStore(),
      fetchRecipeListing = _useRecipeListingStor.fetchRecipeListing,
      recipeListingContent = _useRecipeListingStor.recipeListingContent,
      recipeListing = _useRecipeListingStor.recipeListing,
      fetchRecipeListingContent = _useRecipeListingStor.fetchRecipeListingContent,
      isStatic = _useRecipeListingStor.isStatic;
    var router = useRouter();
    var _useSlug = useSlug(),
      transformSlugsForSeo = _useSlug.transformSlugsForSeo;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta;
    var parentCategory = computed(function () {
      var _recipeListingContent, _recipeListingContent2, _recipeListingContent3, _recipeListingContent4, _recipeListingContent5, _recipeListingContent6;
      return recipeListingContent === null || recipeListingContent === void 0 ? void 0 : (_recipeListingContent = recipeListingContent.value) === null || _recipeListingContent === void 0 ? void 0 : (_recipeListingContent2 = _recipeListingContent.linkedFrom) === null || _recipeListingContent2 === void 0 ? void 0 : (_recipeListingContent3 = _recipeListingContent2.itemTileCollection) === null || _recipeListingContent3 === void 0 ? void 0 : (_recipeListingContent4 = _recipeListingContent3.items[0]) === null || _recipeListingContent4 === void 0 ? void 0 : (_recipeListingContent5 = _recipeListingContent4.linkedFrom) === null || _recipeListingContent5 === void 0 ? void 0 : (_recipeListingContent6 = _recipeListingContent5.pageGenericCategoryCollection) === null || _recipeListingContent6 === void 0 ? void 0 : _recipeListingContent6.items[0];
    });
    var breadcrumbs = computed(function () {
      var _parentCategory$value, _parentCategory$value2, _recipeListingContent7, _recipeListingContent8;
      return [{
        link: app.localePath({
          name: 'index'
        }),
        text: i18n.t('utils.homeBreadcrumbs')
      }, {
        link: app.localePath("/category/".concat((_parentCategory$value = parentCategory.value) === null || _parentCategory$value === void 0 ? void 0 : _parentCategory$value.slug)),
        text: (_parentCategory$value2 = parentCategory.value) === null || _parentCategory$value2 === void 0 ? void 0 : _parentCategory$value2.title
      }, {
        link: app.localePath("/recipes/".concat((_recipeListingContent7 = recipeListingContent.value) === null || _recipeListingContent7 === void 0 ? void 0 : _recipeListingContent7.slug)),
        text: (_recipeListingContent8 = recipeListingContent.value) === null || _recipeListingContent8 === void 0 ? void 0 : _recipeListingContent8.title
      }].filter(function (breadcrumb) {
        return !breadcrumb.link.includes('undefined');
      });
    });
    var pageSchema = z.coerce.number().catch(1);
    var page = computed(function () {
      var parsedPage = pageSchema.parse(route.query.page);
      return parsedPage > 0 ? parsedPage - 1 : 0;
    });
    var recipeListingFilter = computed(function () {
      var _recipeListingContent9;
      if (isStatic.value) {
        var _recipeListing$value;
        return recipeListing === null || recipeListing === void 0 ? void 0 : (_recipeListing$value = recipeListing.value) === null || _recipeListing$value === void 0 ? void 0 : _recipeListing$value.filter(function (recipe) {
          return recipe.recipeId;
        }).map(function (recipe) {
          return "id: ".concat(recipe.recipeId);
        }).join(' OR ');
      } else if ((_recipeListingContent9 = recipeListingContent.value) !== null && _recipeListingContent9 !== void 0 && _recipeListingContent9.algoliaCollections) {
        return "_collections: ".concat(recipeListingContent.value.algoliaCollections);
      }
    });
    var _useLazyAsyncData = useLazyAsyncData("fetch-recipe-listing-".concat(route.params.slug), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _recipeListingContent0, _recipeListingContent1;
        var seo;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!recipeListingContent.value || isStatic.value)) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return fetchRecipeListingContent();
            case 3:
              if (recipeListingContent.value) {
                _context.next = 6;
                break;
              }
              error({
                statusCode: 404
              });
              return _context.abrupt("return", true);
            case 6:
              seo = _objectSpread(_objectSpread({
                title: (_recipeListingContent0 = recipeListingContent.value) === null || _recipeListingContent0 === void 0 ? void 0 : _recipeListingContent0.title
              }, (_recipeListingContent1 = recipeListingContent.value) === null || _recipeListingContent1 === void 0 ? void 0 : _recipeListingContent1.seo), {}, {
                slug: transformSlugsForSeo(recipeListingContent.value)
              });
              setMeta(seo);
              _context.next = 10;
              return fetchRecipeListing();
            case 10:
              return _context.abrupt("return", true);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))),
      loading = _useLazyAsyncData.pending,
      refresh = _useLazyAsyncData.refresh;
    function clearURL() {
      router.push({
        query: {}
      });
    }
    function numberOfPage(data) {
      return Math.max(1, Math.ceil(data / HITS_PER_PAGE));
    }
    watch(function () {
      return route.query.page;
    }, function (newPage) {
      if (newPage && process.client) {
        instantScrollTo({
          top: 0
        });
      }
    });
    return {
      __sfc: true,
      isInRecipesWishlists: isInRecipesWishlists,
      removeRecipeFromWishlist: removeRecipeFromWishlist,
      toggleAddRecipeToWishlistSidebar: toggleAddRecipeToWishlistSidebar,
      navigateToOrLogin: navigateToOrLogin,
      isAuthenticated: isAuthenticated,
      isMobile: isMobile,
      route: route,
      i18n: i18n,
      app: app,
      error: error,
      filtersRecipes: filtersRecipes,
      sortsRecipes: sortsRecipes,
      searchQuery: searchQuery,
      updateRecipeWishlist: updateRecipeWishlist,
      sidebar: sidebar,
      openSidebar: openSidebar,
      fetchRecipeListing: fetchRecipeListing,
      recipeListingContent: recipeListingContent,
      recipeListing: recipeListing,
      fetchRecipeListingContent: fetchRecipeListingContent,
      isStatic: isStatic,
      router: router,
      transformSlugsForSeo: transformSlugsForSeo,
      setMeta: setMeta,
      parentCategory: parentCategory,
      breadcrumbs: breadcrumbs,
      pageSchema: pageSchema,
      page: page,
      recipeListingFilter: recipeListingFilter,
      loading: loading,
      refresh: refresh,
      clearURL: clearURL,
      numberOfPage: numberOfPage,
      AzRichText: AzRichText,
      AzIcon: AzIcon,
      CardSkeleton: CardSkeleton,
      BlockCategoryTagsGraphql: BlockCategoryTagsGraphql,
      AppCategoriesHeader: AppCategoriesHeader,
      AzRadio: AzRadio,
      AzBackToTopButton: AzBackToTopButton,
      SortSelector: SortSelector,
      AzPagination: AzPagination,
      AzButton: AzButton,
      MobileFiltersButton: MobileFiltersButton,
      AzRecipeCard: AzRecipeCard,
      AzFilter: AzFilter,
      AzAccordionItem: AzAccordionItem,
      AisConfigure: AisConfigure,
      AisHits: AisHits,
      AisRefinementList: AisRefinementList,
      AisSortBy: AisSortBy,
      AisStats: AisStats,
      AisClearRefinements: AisClearRefinements,
      AzSidebar: AzSidebar,
      AzButtonText: AzButtonText,
      HITS_PER_PAGE: HITS_PER_PAGE
    };
  }
});